module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige8-6834e51820dd5029417767357e465719.jpg";